import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonText", "onClick", "upgradeData"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url';
import { getAcademyTrialRedirectLink } from '../../../../trial/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TrialRedirectButton = _ref => {
  let {
      buttonText,
      onClick = () => {},
      upgradeData: {
        app,
        upgradeProduct
      }
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const academySuccessButtonProps = app === 'learning-center' ? {
    external: true,
    // replace with getAcademyTrialRedirectLinkFromApiName when trialGuide supports apiNames
    href: getAcademyTrialRedirectLink(upgradeProduct) // href is required only for the external icon to show up
  } : undefined;
  const handleClick = () => {
    if (app === 'learning-center') {
      // replace with getAcademyTrialRedirectLinkFromApiName when trialGuide supports apiNames
      openNewTab(getAcademyTrialRedirectLink(upgradeProduct));
    }
    onClick();
  };
  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    onClick: handleClick
  }, academySuccessButtonProps, rest, {
    children: buttonText || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.activationModal.getStarted"
    })
  }));
};
export default TrialRedirectButton;